import { AiQuickAdd } from "../features/ai-input/AiQuickAdd.js";
import { DailyDigest } from "../features/ai-input/DailyDigest.js";

export function AiRoute() {
  return (
    <div className="mx-auto flex max-w-3xl flex-col gap-6">
      <h1 className="text-2xl font-semibold">Claude</h1>
      <AiQuickAdd />
      <DailyDigest />
    </div>
  );
}
